<div class="irembogov-irembo-section-message">
  <ngb-alert
    #alert
    [type]="type"
    [dismissible]="dismissible"
    *ngIf="openAlert && type !== 'error'">
    <strong class="title d-block text-capitalize">{{ title }}</strong>
    <div class="message my-2">{{ message }}</div>
    <ng-container *ngIf="extraMessage">
      <div class="small message my-2" *ngIf="!extraMessageAsHtml">
        {{ extraMessage }}
      </div>
      <div
        class="small message my-2"
        *ngIf="extraMessageAsHtml"
        [innerHtml]="extraMessage"></div>
    </ng-container>
    <div
      *ngIf="actionText"
      class="action-link text-capitalize"
      (click)="onActionClicked()"
      (keyup)="onActionClicked()">
      {{ actionText }}
    </div>
  </ngb-alert>
  <div class="custom-error-message" *ngIf="type === 'error'">
    <div *ngIf="title" class="title-text">{{ title }}</div>
    <div *ngIf="message">{{ message }}</div>
    <ng-container *ngIf="extraMessage">
      <div *ngIf="!extraMessageAsHtml">{{ extraMessage }}</div>
      <div *ngIf="extraMessageAsHtml" [innerHtml]="extraMessage"></div>
    </ng-container>
  </div>
</div>
